import classNames from "classnames"
import { useController } from "react-hook-form"

// Components
import If from "@mobi/components/If"

// Styles
import "./Checkbox.scss"

import Check from "@mobi/ds/static/icons/outlined/check.svg"

interface ICheckbox {
  /** Nome e id do checkbox */
  name: string
  /** Controle de campo pelo useForms() do react-hooks-form */
  control: any
  /** Texto de label ao lado do checkmark, opcional */
  label?: string
  /** Boolean de se o campo é desabilitado */
  isDisabled?: boolean
  /** Classes para customização */
  className?: string
  /** Para conteúdo de label customizada */
  children?: any
  /** Para controlar a obrigatoriedade do campo */
  required?: boolean
}

const Checkbox = ({
  name,
  isDisabled,
  label,
  className,
  control,
  required,
  children,
  ...props
}: ICheckbox) => {
  const rules = { required }
  const { field } = useController({ name, control, rules })
  const isChecked = field.value

  const checkboxClass = classNames("ds-checkbox", className)
  
  const markupClass = classNames("ds-checkbox__input", {
    "ds-checkbox__input--disabled": isDisabled,
  })
  
  const labelClass = classNames("ds-checkbox__label", {
    "ds-checkbox__label--disabled": isDisabled,
    "ds-checkbox__label--checked": isChecked,
  })
  const labelContent = children || label

  return (
    <div className={checkboxClass}>
      <div className="ds-checkbox__field">
        <div className="ds-checkbox__markup">
          <input
            {...field}
            {...props}
            name={name}
            id={name}
            type="checkbox"
            className={markupClass}
            disabled={isDisabled}
            checked={isChecked}
            onChange={e => {
              props.onChange && props.onChange(e)
              field.onChange(e)
            }}
          />
          <If
            condition={labelContent}
            renderIf={<Check className="ds-checkbox__icon" />}
          />
        </div>
        <If
          condition={labelContent}
          renderIf={
            <label className={labelClass} htmlFor={name} dangerouslySetInnerHTML={{__html: labelContent}} />
          }
        />
      </div>
    </div>
  )
}

export default Checkbox
